import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { formatDate } from 'ngx-bootstrap/chronos';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { EntregasAnalise } from '../../models/entregas-analise.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { EntregasAnaliseService } from '../../services/entregas-analise.service';
import { NavigationService } from '../../services/navigation.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-entrega-projeto-analise-edit',
  templateUrl: './detalhe-entrega-projeto-analise-edit.component.html',
  styleUrls: ['./detalhe-entrega-projeto-analise-edit.component.scss']
})
export class DetalheEntregaProjetoAnaliseEditComponent extends BaseFormComponent<EntregasAnalise> implements OnInit {

  idProjeto: number;
  idEntrega: number;
  analise: EntregasAnalise;
  infoProjeto: ProjetoCadastro;
  actionLabel: string = 'Nova';
  list: any;
  listUsuario: any[];
  audit: AtualizacoesAudit;

  constructor(
    private myService: EntregasAnaliseService,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService,
    public maskService: MaskService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      
      this.list = this.activatedRoute.snapshot.data['list'];
      if (!this.entity?.id && this.activatedRoute.snapshot.queryParams['prt_issue_id']) {
        this.idEntrega = this.activatedRoute.snapshot.queryParams['prt_issue_id'];
      }
      this.initForm();
      this.loaded();
    });    
  }

  initList() {
    this.loading();
    this.addSub(this.myService.getById(this.entity?.id).subscribe((res) => {
      this.entity = res;
      this.initForm();
      this.loaded();
    }))
  }

  initForm() {
    this.form = new FormGroup({
      description: new FormControl('', [Validators.required]),
      prt_issue_id: new FormControl(null),
      extras: new FormArray([]),
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);

      this.audit = {
        prt_analysis_id: this.entity.id
      };

      this.entity?.extras?.forEach((item) => {
        item.decimal_places = String(item?.decimal_places);
        this.getFormArray().push(this.createFormGroup(item))
      })
    }
  }

  voltar() {
    if (this.entity?.id) {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, 'entregas', this.entity?.prt_issue_id]);
    } else {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, 'entregas', this.idEntrega]);
    }
  }

  getDataCreate(): EntregasAnalise {
    let data: EntregasAnalise;
    data = Object.assign({}, data, this.form.value);

    if (!this.entity?.id && this.idEntrega) {
      data.prt_issue_id = this.idEntrega;
    }


    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res) => {
              this.confirmation('Análise alterada com sucesso!').subscribe(() => {
                this.initList()
              });
              EventSharedService.get('auditRefresh').emit();
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res) => {
              this.confirmation().subscribe(() => {
                this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'entregas', 'analise', res.id, 'editar']);
              })
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }

  dataMask(event, field) {
    const inputValue = event.target.value;
    const sanitizedValue = inputValue.replace(/[^0-9/]/g, '');
    this.form.get(field).setValue(sanitizedValue);
  }

  createFormGroup(values = null): FormGroup {
    return new FormGroup({
      id: new FormControl(values?.value_id),
      extra_id: new FormControl(values?.extra_id),
      title: new FormControl(values?.title),
      unit_id: new FormControl(values?.unit_id),
      decimal_places: new FormControl(values?.decimal_places),
      done: new FormControl(null, [Validators.required]),
      value_done_last_one: new FormControl(values?.value_done_last_one),
      goal: new FormControl(values?.goal),
    });
  }

  getFormArray(): FormArray {
    return this.form.get('extras') as FormArray;
  }

  formatarMedidaFisica(index: number) {
    let goalValue = this.getFormArray().controls[index].get('done')?.value;
    let decimalPlacesValue = this.getFormArray().controls[index].get('decimal_places')?.value;
    let value = this.maskService.formatarMedidaFisica(goalValue, decimalPlacesValue);
    this.getFormArray().controls[index].get('done').setValue(value);
  }

  fieldMessageRequireds(field, index: number): boolean {
    return this.getFormArray().controls[index].get(field).invalid && this.getFormArray().controls[index].get(field).dirty;
  }

  fieldErrosFormArray(field, index: number) {
    return this.getFormArray().controls[index].get(field)?.errors;
  }
}
